/**
 * La copie qu'un élève rend à la fin d'un quiz (défi, séance en ligne ou
 * évaluation), sous la forme attendue par le back, avec un seul ajout qui
 * change tout : `termine`.
 *
 * Décision prof 2026-09-14 : l'XP ne se gagne qu'en finissant. Une copie
 * envoyée à la sortie (bouton Quitter, fermeture de l'onglet, retour du
 * navigateur) est enregistrée comme les autres, blancs compris, pour que le
 * professeur voie les réponses données ; mais elle porte `termine: false` et
 * le back ne crédite alors aucune XP. Le juge reste le back (`termine` vrai ET
 * aucune réponse vide) : le champ dit l'intention, il ne la force pas.
 *
 * @param {object} p
 * @param {boolean} p.termine        - true en fin de quiz, false à la sortie
 * @param {boolean} p.isDefi
 * @param {boolean} p.isSession
 * @param {number|string} p.evaluationId - id de séance ou d'évaluation (hors défi)
 * @param {number|string} p.eleveId
 * @param {number|string} p.classeId
 * @param {object} p.reponses        - les réponses (déjà passées par annoterCopie hors défi : aide et erreurs)
 * @param {object} [p.defi]          - le corps du défi (buildDefiPayload), quand isDefi
 * @param {number|string} [p.rejeuDe] - id du quiz en ligne rejoué : un rejeu est un défi qui porte `session_id`
 */
export const payloadCopie = ({ termine, isDefi, isSession, evaluationId, eleveId, classeId, reponses, defi, rejeuDe }) => {
    if (isDefi) return { ...defi, ...(rejeuDe != null ? { session_id: rejeuDe } : {}), termine: termine === true };
    return {
        [isSession ? 'session_id' : 'evaluation_id']: evaluationId,
        eleve_id: eleveId,
        reponses: { reponses },
        classe_id: parseInt(classeId, 10),
        termine: termine === true,
    };
};
